import { User } from '@sparx/api/apis/sparx/reading/users/v1/sessions';

export const createDisplayName = (user: User | undefined, noun: string | undefined) =>
  noun && user ? `${user.firstName} the ${noun}` : undefined;
